import Box from '@mui/material/Box'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import { GenericDialog, MButton } from 'components'
import { Typography } from '@mui/material'
import { color } from 'config/color'

export const UnregisterConfirmDialog = ({
  open,
  isLoading,
  onClose,
  onConfirm
}: any): JSX.Element => {
  const isMobile = useMobileBreakpoints()
  return (
    <Box>
      <GenericDialog
        open={open}
        onClose={onClose}
        isLoading={isLoading}
        title="Unregister Account"
        iconType="warning"
      >
        <Box>
          <Typography
            color={color.grey[700]}
            fontSize={isMobile ? 14 : 16}
            textAlign={isMobile ? 'justify' : 'center'}
          >
            Are you sure you want to unregister your account?
          </Typography>

          <Typography
            color={color.grey[700]}
            fontSize={isMobile ? 14 : 16}
            textAlign={isMobile ? 'justify' : 'center'}
            mb={3}
          >
            This action cannot be undone.
          </Typography>

          <Box display="flex" flexDirection="row" gap={1}>
            <MButton
              variant="contained"
              type="button"
              size="large"
              rounded="true"
              fullWidth
              onClick={onConfirm}
              texttransform="none"
              disabled={isLoading}
            >
              Yes, unregister account
            </MButton>
            <MButton
              variant="outlined"
              type="button"
              size="large"
              rounded="true"
              fullWidth
              onClick={onClose}
              texttransform="none"
              disabled={isLoading}
            >
              No, keep my account
            </MButton>
          </Box>
        </Box>
      </GenericDialog>
    </Box>
  )
}
